'use strict';

angular.module('webmailWrapper')
    .controller('EmailDeleteCtrl', function ($scope, $modalInstance, mailboxes, mailboxModel, alertManager, translationProvider) {
        $scope.mailboxes = mailboxes;
        $scope.data = {warningRead: false};

        $scope.submit = function (form) {
            $scope.$broadcast('show-errors-check-validity');
            if (form.$invalid) {
                return;
            }

            mailboxModel.delete(mailboxes, true).then(function () {
                alertManager.success(translationProvider.instant('TR_070525-eed4ee_TR'));
                $modalInstance.close();
            }, function () {
                alertManager.error(translationProvider.instant('TR_070525-8fc8f7_TR'));
            });
        };
    });
